import http from "../http-common";

class ContactMapDataService {
    getContacts() {
        return http.get("/crm/contacts/map");
    }
}

export default new ContactMapDataService();
